<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <h2 class="mb-xs mb-2">
          Your current loan balance is {{ filters.currency(todayPayoffBalance) }}.
        </h2>
        <p>
          To help you avoid the serious consequences of defaulting on your loan, we are offering
          you two simple options for resolving your debt.
        </p>
      </v-col>
    </v-row>
    <v-row
      v-if="isValidSettlementStatus"
      align="center"
      justify="center"
    >
      <v-col cols="auto">
        <v-btn
          x-large
          outlined
          @click="goToSinglePaymentView"
        >
          Single Payment Option
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          x-large
          outlined
          @click="goToReducedPayoffPaymentView"
        >
          Reduced Payoff Plan Option
        </v-btn>
      </v-col>
    </v-row>
    <v-card-text
      v-else
    >
      <v-alert
        type="warning"
      >
        <p>This loan is not eligible for settlement.</p>
      </v-alert>
    </v-card-text>
  </v-container>
</template>

<script>

import { useFilters } from '@/composables/useFilters.js';

export default {
  name: 'SettlementOptions',

  props: {
    todayPayoffBalance: {
      type: Number,
      required: true,
    },
    isValidSettlementStatus: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const filters = useFilters();
    return { filters };
  },

  data() {
    return {

    };
  },

  methods: {
    goToSinglePaymentView() {
      this.$emit('display-single-payment-option-view');
    },
    goToReducedPayoffPaymentView() {
      this.$emit('display-reduced-payoff-plan-option-view');
    },
  },
};
</script>
